import { formatDate } from "@utils/date.util";

const tableTitle = "Manufacturer List";
const keyColumn = "id";
const menuUrl = "inventory/manufacturers";

const tableColumn = [
  {
    id: "profile_image",
    numeric: false,
    disablePadding: false,
    label: "Profile Image",
    type: "FILE_UPLOAD",
    formatData: (data) => {
      return (
        <img
          src={data}
          alt="Profile Image"
          style={{ width: "100px", height: "50px" }}
        />
      );
    },
  },
  {
    id: "manufacturer_name",
    numeric: false,
    disablePadding: false,
    label: "Manufacturer Name",
  },
  
   {
            id: "created_at",
            numeric: false,
            disablePadding: false,
            label: "Created At",
            formatData: formatDate,
            sort: true,
          },
  {
    id: "status",
    numeric: false,
    disablePadding: false,
    label: "Status",
    isBadge: true,
    primaryKey: keyColumn,
    badgeText: {
      1: "Enable",
      2: "Disable",
    },
    badgeColor: {
      1: "success",
      2: "danger",
    },

  },
];

const breadCrumbs = [
  { name: "Manufacturers", menu_url: "/inventory/manufacturers" },
];

const filters = () => [
  {
    name: "manufacturer_name",
    id: "manufacturer_name",
    label: "Manufacturer Name",
    value: "",
    type: "TEXT",
    validations: [],
    isVertical: true,
    groupClass: "col-md-3",
  },
  
];

export {
  tableTitle,
  keyColumn,
  tableColumn,
  breadCrumbs,
  menuUrl,
  filters,
};
